import * as React from 'react';

const AttachmentIcon = (props) => (
  <svg
    width={18}
    height={19}
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.80312 2.13625C9.56878 0.370599 12.4315 0.370598 14.1971 2.13625C15.9628 3.9019 15.9628 6.76459 14.1971 8.53025L8.86378 13.8636C7.83451 14.8929 6.16573 14.8929 5.13646 13.8636C4.10718 12.8343 4.10718 11.1655 5.13646 10.1363L10.4698 4.80292C10.7627 4.51003 11.2376 4.51003 11.5305 4.80292C11.8233 5.09581 11.8233 5.57069 11.5305 5.86358L6.19712 11.1969C5.75363 11.6404 5.75363 12.3594 6.19712 12.8029C6.6406 13.2464 7.35964 13.2464 7.80312 12.8029L13.1365 7.46959C14.3163 6.28972 14.3163 4.37678 13.1365 3.19691C11.9566 2.01704 10.0436 2.01705 8.86378 3.19691L3.53045 8.53025C1.6142 10.4465 1.6142 13.5533 3.53045 15.4696C5.44669 17.3858 8.55354 17.3858 10.4698 15.4696L15.8031 10.1363C16.096 9.84336 16.5709 9.84336 16.8638 10.1363C17.1567 10.4291 17.1567 10.904 16.8638 11.1969L11.5305 16.5302C9.02842 19.0323 4.97182 19.0323 2.46979 16.5303C-0.0322448 14.0282 -0.0322483 9.97162 2.46978 7.46959L7.80312 2.13625Z"
      fill="currentcolor"
    />
  </svg>
);

export default AttachmentIcon;
